@if ($buttonToggleGroup) {
  <mat-button-toggle
    [value]="value"
    #toggleButton
    appearance="legacy"
    [hideSingleSelectionIndicator]="true"
    [disableRipple]="true"
    [disabled]="disabled"
    >
    <slot></slot>
  </mat-button-toggle>
}
